module.exports = __webpack_public_path__ + "static/media/happy man.d5b9fa18.png";